import PropTypes from "prop-types";
import React, { Component } from "react";
import { MSpinner, MCollapsibleCard } from "components/Shared";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";

class FormIssues extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };
  }

  render() {
    const { isFetching, caseForms, comparableValidationResult, items } = this.props;
    return (
      <MCollapsibleCard
        title="Form Validation"
        expanded={!this.state.collapsed}
        onExpandedChange={(expanded) => this.setState({ collapsed: !expanded })}
        wrapperClassName=""
      >
        {isFetching
          ? <MSpinner />
          : <FormIssuesList items={items} caseForms={caseForms} comparableValidationResult={comparableValidationResult} />
        }
      </MCollapsibleCard>
    );
  }
}

FormIssues.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  items: PropTypes.array,
  caseForms: PropTypes.array.isRequired,
  comparableValidationResult: PropTypes.array.isRequired
};

class FormIssuesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pnxExpanded: {},
      compsExpanded: false,
    };
    this.togglePnx = this.togglePnx.bind(this);
    this.toggleComps = this.toggleComps.bind(this);
  }

  togglePnx(formName) {
    let pnxCol = {...this.state.pnxExpanded};
    pnxCol[formName] = pnxCol[formName] ? false : true;
    this.setState({ pnxExpanded: pnxCol });
  }
  toggleComps() {
    this.setState({ compsExpanded: !this.state.compsExpanded });
  }

  render() {
    const { items, comparableValidationResult } = this.props;

    if (items.length == 0 && !comparableValidationResult.length) {
      return <p>No Form Validation issues.</p>;
    }

    let failedPerForm = {};
    items.map((result) => {
      if(failedPerForm[result.formName]){
        failedPerForm[result.formName].push({...result});
      } else {
        failedPerForm[result.formName] = [];
        failedPerForm[result.formName].push({...result});
      } 
    });

    return (
      <div className="veros-override-grid">
        <div className="md-table-column--header md-text--secondary" style={{ height: "auto", textAlign: "left" }}>
          Form Action Message
      </div>
        <TableContainer component="div" className="md-cell--12"
          style={{ maxHeight: 500, borderTopColor: "lightgray", borderTopStyle: "solid", borderTopWidth: "thin" }}>
          <Table>
          <TableBody>
            {Object.keys(failedPerForm).map(formName => (
              <TableRow key={formName}>
                <TableCell colSpan={1} style={{ padding: 0, border: 'none' }}>
                <MCollapsibleCard
                  title={`${formName} has ${failedPerForm[formName].length} failed validation${failedPerForm[formName].length === 1 ? "" : "s"}.`}
                  expanded={this.state.pnxExpanded[formName] || false}
                  onExpandedChange={(expanded) => {
                    let pnxCol = {...this.state.pnxExpanded};
                    pnxCol[formName] = expanded;
                    this.setState({ pnxExpanded: pnxCol });
                  }}
                  wrapperClassName=""
                >
                  <b>{formName}</b>
                    <ul>
                      {failedPerForm[formName]?.map(s => {
                        return s.messages.map(p => (<li key={p}>{p}</li>));
                      })}
                    </ul>    
                </MCollapsibleCard>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={1} style={{ padding: 0, border: 'none' }}>
              <MCollapsibleCard
                title={`Comparables with Comparable Search has ${comparableValidationResult.length} failed validation${comparableValidationResult.length === 1 ? "" : "s"}.`}
                expanded={this.state.compsExpanded}
                onExpandedChange={(expanded) => this.setState({ compsExpanded: expanded })}
                wrapperClassName=""
              >
                <ul>
                  {comparableValidationResult.map(s => (<li key={s.message}>{s.message}</li>))}
                </ul>
              </MCollapsibleCard>
              </TableCell>
            </TableRow>
          </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }
}

FormIssuesList.propTypes = {
  items: PropTypes.array.isRequired,
  caseForms: PropTypes.array.isRequired,
  comparableValidationResult: PropTypes.array.isRequired
};

export { FormIssues, FormIssuesList };
